module.exports = __webpack_public_path__ + "static/media/versace-eros-pour-femme-big.0171078a.png";